import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../layout/index'
import axios from 'axios'
import store from '../store'
import i18n from '../lang/lang'
import ElementLocale from 'element-ui/lib/locale';
import zhTW from 'element-ui/lib/locale/lang/zh-TW';
import en from 'element-ui/lib/locale/lang/en';

Vue.use(VueRouter)


/**
 * 一般使用者 F123456790
 * 多表用戶主帳號 84894989-0
 * 多表用戶子帳號 84894989-1 到 84894989-31
 */
// const testAccount = 'F123456790'
const testAccount = 'F123456789'
// const testAccount = '84894989-0'
// const testAccount = '84894989-1'

// 單表或多表用戶帳密
const password = '1qaz!QAZ1qaz'

/* 分處使用者 0001@water.gov.taipei */

// const testAccount = 'SSO@water.gov.taipei'
// const testAccount = '0001@water.gov.taipei'
// const password = 'abcd1234'

// 取得目前登入使用者的基本資訊 判斷要轉導的頁面
function redirectByAccountType(next) {
  axios.get('/api/system/citizen/current').then(res => {
    // console.log(res)
    if (res) {
      let accountType = res.data.type
      let loginAccount = res.data.account
      localStorage.setItem('accountType', accountType) // 將 accountType 存至 localStorage
      localStorage.setItem('loginAccount', loginAccount) // 將 loginAccount 存至 localStorage
      localStorage.setItem('name', res.data.name) // 將 name 存至 localStorage
      let currentProfile = {
        waterId: res.data.waterId,
        waterNum: res.data.waterNum
      }
      // console.log('accountType', accountType)
      switch (accountType) {
        case 'citizen': // 一般使用者
          localStorage.setItem('currentProfile', JSON.stringify(currentProfile)) // 將 currentProfile 存至 localStorage (物件要先字串化)
          next({ name: '用水狀況' })
          break;
        case 'group': // 多表用戶主帳號
          next({ name: '用戶清單' })
          break;
        case 'group_member': // 多表用戶子帳號 20250108 12-35用戶整合系統跳轉過來問題: 多表用戶子帳號也要跳到用戶清單才能去選水栓取得waterId
          // localStorage.setItem('currentProfile', JSON.stringify(currentProfile)) // 將 currentProfile 存至 localStorage (物件要先字串化)
          next({ name: '用戶清單' })
          break;
        case 'unit': // 分處使用者
          localStorage.setItem('unitId', res.data.unitId) // 將 unitId 存至 localStorage
          next({ name: '監測圖台' })
          break;
      }
    }
  })
}

// 來自 Bms，將waterId waterNum 存至 currentProfile 轉導到用水狀況
async function redirectByBMS(next, currentProfile) {
  // console.log('redirectByBMS')
  // 取得目前登入使用者的基本資訊
  await axios.get('/api/system/citizen/current').then(res => {
    if (res) {
      let accountType = res.data.type
      let loginAccount = res.data.account
      localStorage.setItem('accountType', accountType) // 將 accountType 存至 localStorage
      localStorage.setItem('loginAccount', loginAccount) // 將 loginAccount 存至 localStorage
      localStorage.setItem('name', res.data.name) // 將 name 存至 localStorage 
    }
  })
  // 來自 Bms，將waterId waterNum 存至 currentProfile 轉導到用水狀況
  localStorage.setItem('currentProfile', JSON.stringify(currentProfile)) // 將 currentProfile 存至 localStorage (物件要先字串化)
  next({ name: '用水狀況' })
}


const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    beforeEnter: async (to, from, next) => {
      // 清空 localstorage
      // localStorage.clear()
      // 先用測試 API 進行登錄
      // await axios.post('/login?username=' + testAccount  + '&password=' + password).then(() => {
      //   console.log('登入成功')
      // })
      // 取得目前登入使用者的基本資訊 判斷要轉導的頁面
      redirectByAccountType(next)
    }
  },
  {
    // 由業務管理系統跳轉過來
    path: '/bms-redirect/:waterId/:waterNum',
    name: 'Layout',
    component: Layout,
    beforeEnter: async (to, from, next) => {
      // 清空 localstorage
      localStorage.clear()
      
      let currentProfile = {
        waterId: to.params.waterId,
        waterNum: to.params.waterNum
      }

      // 將 waterId waterNum 存至 currentProfile 轉導到用水狀況
      redirectByBMS(next, currentProfile)
    }
  },
  {
    path: '/',
    name: 'home',
    component: Layout,
    children: [
      {
        path: 'home',
        name: '首頁',
        component: (resolve) => require(['@/views/HomeView'], resolve),
      },
      {
        path: 'monitorMap',
        name: '監測圖台',
        component: (resolve) => require(['@/views/MonitorMap'], resolve),
        beforeEnter: async (to, from, next) => {
          // 清空 localstorage 的 currentProfile , 直到再次指定用戶
          localStorage.removeItem('currentProfile')
          next()
        }
      },
      {
        path: 'monitorMap_GoogleMaps',
        name: '監測圖台',
        component: (resolve) => require(['@/views/MonitorMap_GoogleMaps.vue'], resolve),
        beforeEnter: async (to, from, next) => {
          // 清空 localstorage 的 currentProfile , 直到再次指定用戶
          localStorage.removeItem('currentProfile')
          next()
        }
      },
      {
        path: 'profileGroupList',
        name: '用戶清單',
        component: (resolve) => require(['@/views/ProfileGroupList'], resolve),
        beforeEnter: async (to, from, next) => {
          // 清空 localstorage 的 currentProfile , 直到再次指定用戶
          localStorage.removeItem('currentProfile')
          next()
        }
      },
      {
        path: 'groupAlarmList',
        name: '異常病例統計',
        component: (resolve) => require(['@/views/GroupAlarmList'], resolve),
        beforeEnter: async (to, from, next) => {
          // 清空 localstorage 的 currentProfile , 直到再次指定用戶
          localStorage.removeItem('currentProfile')
          next()
        }
      },
      {
        path: 'CommunityGroupList',
        name: '社區用水',
        component: (resolve) => require(['@/views/CommunityGroupList'], resolve),
        beforeEnter: async (to, from, next) => {
          // 清空 localstorage 的 currentProfile , 直到再次指定用戶
          localStorage.removeItem('currentProfile')
          next()
        }
      },
      {
        path: 'profile',
        name: '用水狀況',
        component: (resolve) => require(['@/views/Profile'], resolve),
        beforeEnter: async (to, from, next) => {
          let currentProfile = JSON.parse(localStorage.getItem('currentProfile'))
          if (!currentProfile) { // 尚未選擇 指定用戶
            next({path: '/'}) // 回首頁
            // router.go(-1)
          } else {
            next()
          }
        }
      },
      {
        path: 'report/test',
        name: '測試功能頁',
        component: (resolve) => require(['@/views/report/Test'], resolve),
      },
      {
        path: 'report/record',
        name: '用水量圖',
        component: (resolve) => require(['@/views/report/Record'], resolve),
      },
      {
        path: 'dailyRawdata',
        name: '用水指針查詢',
        component: (resolve) => require(['@/views/DailyRawdata'], resolve),
      },
      {
        path: 'useNote',
        name: '用水記事',
        component: (resolve) => require(['@/views/UseNote'], resolve),
      },
      {
        path: 'viewSetting',
        name: '用戶顯示管理設定',
        component: (resolve) => require(['@/views/ViewSetting'], resolve),
      },
      {
        path: 'billing',
        name: '收費期別計量',
        //component: (resolve) => require(['@/views/Billing'], resolve),
        beforeEnter: async () => {
          let currentProfile = JSON.parse(localStorage.getItem('currentProfile'))
          let tempWaterNum = currentProfile.waterNum
          //tempWaterNum ='dfadg222##@ff'
          tempWaterNum = tempWaterNum.replaceAll('-',"")
          tempWaterNum = tempWaterNum.replace(/[^\w]+/g,"")
          //console.log('replace =',tempWaterNum)
          //https://mbr.water.gov.taipei/wtsvapi/nologinbywid/{水號}/W2
          if (tempWaterNum) {
            window.open("https://mbr.water.gov.taipei/wtsvapi/nologinbywid/"+tempWaterNum+'/W2','_blank')
          }
        }
      },
      {
        path: 'health',
        name: '體檢卡',
        component: (resolve) => require(['@/views/health/HealthCheck'], resolve),
      },
      {
        path: 'alarmSetting',
        name: '警示設定',
        component: (resolve) => require(['@/views/AlarmSetting'], resolve),
      },
      {
        path: 'waterFee',
        name: '水費試算',
        //component: (resolve) => require(['@/views/WaterFee'], resolve),
        beforeEnter: async () => {
          let currentProfile = JSON.parse(localStorage.getItem('currentProfile'))
          let tempWaterNum = currentProfile.waterNum
          tempWaterNum = tempWaterNum.replaceAll('-',"")
          tempWaterNum = tempWaterNum.replace(/[^\w]+/g,"")
         // console.log('tempWaterNum =',tempWaterNum)
         if (tempWaterNum) {
          window.open("https://mbr.water.gov.taipei/calctemp/"+tempWaterNum,'_blank')
         }
        }
      },
      {
        path: 'link',
        name: '相關連結',
        component: (resolve) => require(['@/views/Link'], resolve),
      },
      {
        path: 'link/waterMeter',
        name: '智慧水表',
        beforeEnter(){
          window.open("https://www.water.gov.taipei/cp.aspx?n=2E9B17EFBF12FB2C",'_blank')
        }
      },
      {
        path: 'link/newInfo',
        name: '最新消息',
        beforeEnter(){
          window.open("https://www.water.gov.taipei/News.aspx?n=7580C646B026F97C&amp;sms=78D644F2755ACCAA",'_blank')
        }
      },
      {
        path: 'link/news',
        name: '新聞稿',
        beforeEnter(){
          window.open("https://www.water.gov.taipei/News.aspx?n=D68F8002AA8566B7&amp;sms=72544237BBE4C5F6",'_blank')
        }
      },
      {
        path: 'link/eBill',
        name: '電子帳單',
        beforeEnter(){
          window.open("https://www.water.gov.taipei/Content_List.aspx?n=6505C646F5152113",'_blank')
        }
      },
      {
        path: 'link/billService',
        name: '帳務服務',
        beforeEnter(){
          window.open("https://www.water.gov.taipei/Content_List.aspx?n=99BA1D28E2CF229B",'_blank')
        }
      },
      {
        path: 'link/waterCut',
        name: '停水資訊',
        beforeEnter(){
          window.open("https://www.water.gov.taipei/cp.aspx?n=4D250114FCEAF4CE",'_blank')
        }
      },
      {
        path: 'link/announce',
        name: '文宣及出版品',
        beforeEnter(){
          window.open("https://www.water.gov.taipei/Content_List.aspx?n=19065A4BCA536F13",'_blank')
        }
      },
      {
        path: 'link/manual',
        name: '系統操作手冊',
        beforeEnter(){
          window.open("https://webpms-watertaipei.cdn.hinet.net/%E6%99%BA%E6%85%A7%E6%B0%B4%E7%AE%A1%E5%AE%B6%E7%B3%BB%E7%B5%B1%E7%B0%A1%E6%98%93%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8A.pdf",'_blank')
        }
      },
      {
        path: 'link/eBook',
        name: '案例電子書',
        beforeEnter(){
          window.open("https://twd.water.gov.taipei/www/download/電子書.pdf",'_blank')
        }
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  // base: publicPath,
  // base: process.env.BASE_URL,
  routes
})

// 每個頁面進入後要重新調整選單內容
router.afterEach((to, from) => {
  console.log('from', from)
  console.log('to', to)
  if (to) {
    store.dispatch("getMenuByCurrentAccount", to)
  }
  if (to.path == '/profile') { // 更新控件語言
    // 切換 Element UI 語系
    const elementLocale = store.state.locale === 'en' ? en : zhTW;
    ElementLocale.use(elementLocale);
  } else {
    ElementLocale.use(zhTW);
  }
})
export default router
